<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div *ngIf="isMemorabid && !inPreEventStatus">
        <h4 class="text-uppercase mb-3">{{'IDS_MEMORABID_AUCTIONS' | translate}}</h4>
        <p>{{'IDS_GOLD_DESCRIPTION_TITLE_HOME' | translate}}</p>
        <p class="mb-3" [innerHTML]="'IDS_GOLD_DESCRIPTION_HOME' | translate" ></p>
    </div>
    <div *ngIf="!isMemorabid && !inPreEventStatus">
        <h4 class="text-uppercase mb-3">{{'IDS_MARKETPLACE_AUCTIONS' | translate}}</h4>
        <p>{{'IDS_MARKETPLACE_DESCRIPTION_TITLE_HOME' | translate}}</p>
        <p class="mb-3" [innerHTML]="'IDS_MARKETPLACE_DESCRIPTION_HOME' | translate" ></p>
    </div>
    <div *ngIf="inPreEventStatus">
      <h4 class="text-uppercase mb-3">{{'IDS_PRE_EVENT_AUCTIONS' | translate}}</h4>
      <p>{{'IDS_PRE_EVENT_AUCTIONS_DESCRIPTION_TITLE_HOME' | translate}}</p>
      <p class="mb-3" [innerHTML]="'IDS_PRE_EVENT_AUCTIONS_DESCRIPTION_HOME' | translate" ></p>
  </div>
</div>
